import { BaseEndpoint, BaseSDK } from '@livefree/js-sdk';

class RecoveryEndpoint extends BaseEndpoint {
  constructor(config) {
    super('api/v1/recovery', config);
  }

  requestToken(username) {
    return super.create({ username });
  }

  validateToken(username, code) {
    const url = super.appendUrl('/validate');
    return super.httpPOST({ url, body: { username, code } });
  }

  resetPassword(username, code, password) {
    const url = super.appendUrl('/reset-password');
    return super.httpPOST({ url, body: { username, code, password } });
  }
}

export class RecoveryClient extends BaseSDK {
  #recovery_endpoint;
  constructor(baseUrl) {
    super(baseUrl);
    this.#recovery_endpoint = new RecoveryEndpoint(this.config);
  }

  requestToken(username) {
    return this.#recovery_endpoint.requestToken(username);
  }

  validateToken(username, code) {
    return this.#recovery_endpoint.validateToken(username, code);
  }

  resetPassword(username, code, password) {
    return this.#recovery_endpoint.resetPassword(username, code, password);
  }
}
